//@flow
import * as React from "react";
import styled from "react-emotion";
import Link from "gatsby-link";
import { theme, mqMin } from "../../styles/theme";
import { Fade } from "react-reveal";

const Wrap = styled.div`
  padding-left: ${theme.space2};
  padding-right: ${theme.space2};
  padding-bottom: ${theme.space3};
  width: 100%;
  ${mqMin(theme.tablet)} {
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
`;

const Intro = styled.div`
  padding-bottom: ${theme.space1};
  ${mqMin(theme.tablet)} {
    padding-top: ${theme.space3};
    padding-bottom: ${theme.space3};
    padding-left: ${theme.space3};
    padding-right: ${theme.space3};
    flex-shrink: 0;
    flex-basis: 40%;
  }
`;
const Heading = styled.h3`
  font-size: ${theme.h2};
  font-family: ${theme.heading.fontFamily};
  font-weight: ${theme.heading.bold};
  line-height: ${theme.lineHeight2};
`;

const Text = styled.p`
  font-family: ${theme.display.fontFamily};
  font-weight: ${theme.display.fontWeight};
  ${mqMin(theme.tablet)} {
    padding-top: ${theme.space3};
    padding-bottom: ${theme.space3};
    font-size: ${theme.h4};
    line-height: ${theme.lineHeight3};
    p:first-of-type: {
      padding-top: ${theme.space1};
    }
    font-size: ${theme.h3};
  }
`;
const Meta = styled.span`
  font-size: ${theme.h4};
  font-family: ${theme.heading.fontFamily};
  font-weight: 400;
`;

export default ({ heading, text, meta, active, uid, progress }) => (
  <Wrap>
    <Intro>
      <Heading>
        <Link to={uid}>{heading}</Link>
      </Heading>
      <Meta>{meta}</Meta>
    </Intro>
    <Text>
      <Link to={uid}>{text}</Link>
    </Text>
  </Wrap>
);



// WEBPACK FOOTER //
// ./src/components/WorkGridItem/index.js